exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".column[data-v-1e576d1c]{flex-direction:column !important}.icons-row[data-v-1e576d1c]{padding:.5rem 1rem;display:flex;width:100%;align-items:center;justify-content:space-between}.icons-row .version[data-v-1e576d1c]{flex:3}.icons-row .theme[data-v-1e576d1c]{display:flex;flex:4;justify-content:flex-end}", ""]);

// exports
